import { SortByInterface } from './sorting';

export const handleSort = (columnName: string, sortConfig: SortByInterface) => {
  return sortConfig.column === columnName && sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
};
